import React, { useState, useEffect } from "react";
import { Form, Input, DatePicker, Button, Select, theme, Space, Breadcrumb, Spin, Layout, Row, Col } from "antd";
import axios from "axios";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import Headerdiv from "../layout/header.js"; // Import Link from react-router-dom
import Footerdiv from "../layout/footer.js";
import { useNavigate } from "react-router-dom";
import { AlertError, AlertSuccess } from '../usableclasses.js';
import { Link } from 'react-router-dom';

const { Content } = Layout;
const { Option } = Select;

const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["clean"],
    ],
};
const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "align",
    "color",
    "background",
];

const GrnCreate = ({ currentUser }) => {

    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const [vendors, setVendors] = useState([]);
    const [targetStock, setTargetStock] = useState([]);
    const [grnNote, setGrnNote] = useState("");
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        fetchVendors();
        fetchStock();
    }, []);

    const fetchVendors = async () => {
        try {
            const response = await axios.get(`${ApiURL}/purchase/poforgrndropdown`, {
                headers: { SystemAccessToken: TOKEN },
            });
            setVendors(response.data);
        } catch (error) {
            AlertError("Failed to load vendors");
        }
    };
    const fetchStock = async () => {
        try {
            const response = await axios.get(`${ApiURL}/stocks/getstockdropdownforgrn`, {
                headers: { SystemAccessToken: TOKEN },
            });
            setTargetStock(response.data);
        } catch (error) {
            AlertError("Failed to load vendors");
        }
    };

    const onFinish = async (values) => {
        const requestData = {
            poId: values.poId,
            stockId: values.stockId,
            vendorBillNo: values.vendorBillNo,
            vendorBillDate: values.vendorBillDate.format("YYYY-MM-DD"),
            grnNote: grnNote,
            createdBy: UPDATED_BY,
        };

        try {
            const response = await axios.post(`${ApiURL}/grn/create`, requestData, {
                headers: { SystemAccessToken: TOKEN },
            });
            if (response.status === 200) {
                
                AlertSuccess("Goods Receive note created successfully");
                navigate(`/grnupdate/${response.data}`);
             
            }
        } catch (error) {
            AlertError("Failed to create Goods Receive note");
        }
    };

    return (
        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px', }} >
                    <Breadcrumb style={{ margin: "16px 0" }}> 
                        <Breadcrumb.Item><Link to="/grnlist">Goods Receive</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Create Goods Recieve Note</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                        <Space
                            direction="vertical"
                            style={{ width: "100%", padding: "15px" }}
                        >
                            <h2>Create a Goods Recieve Note</h2>
                            <Form form={form} layout="vertical" onFinish={onFinish}>
                                <Row>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Target PO"
                                            name="poId"
                                            rules={[{ required: true, message: "Target PO is required" }]}
                                        >
                                            <Select placeholder="Select a Target PO">
                                                {vendors.map((vendor) => (
                                                    <Option key={vendor.id} value={vendor.id}>{vendor.label}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Target Stock"
                                            name="stockId"
                                            rules={[{ required: true, message: "Target Stock is required" }]}
                                        >
                                            <Select placeholder="Select a Target Stock">
                                                {targetStock.map((targetStock) => (
                                                    <Option key={targetStock.id} value={targetStock.id}>{targetStock.label}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Vendor Bill No"
                                            name="vendorBillNo"
                                            rules={[
                                                { required: true, message: "Vendor Bill No is required" },
                                                { max: 30, message: "Maximum 30 characters allowed" },
                                            ]}
                                        >
                                            <Input placeholder="Enter Vendor Bill No" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={6} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Vendor Bill Date"
                                            name="vendorBillDate"
                                            rules={[{ required: true, message: "Vendor Bill Date is required" }]}
                                        >
                                            <DatePicker
                                                disabledDate={(current) => current && current > moment().endOf("day")}
                                                style={{ width: "100%" }}
                                            />
                                        </Form.Item>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={24} style={{ padding: '5px' }}>
                                        <Form.Item label="Goods Receive  Note" name="grnNote">
                                            <ReactQuill
                                                value={grnNote}
                                                onChange={setGrnNote}
                                                modules={modules}
                                                formats={formats}
                                                theme="snow"
                                                placeholder="Enter your description..."
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={24} style={{ padding: '5px',display:'flex',justifyContent:'flex-end',alignItems:'flex-end' }}>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit">Create Goods Receive Note</Button>
                                        </Form.Item>
                                    </Col>
                                </Row>

                            </Form>

                        </Space>
                    </div>
                </Content>
                <Footerdiv />

            </Layout>
        </Spin>
    );
};

export default GrnCreate;
